import { Box, Icon, Tooltip } from '@mui/material';
import type React from 'react';
import { useTranslation } from 'react-i18next';

import getMuiIcon from '../../utils/getMuiIcon';

const AutoSave: React.FC<{ status: 'saved' | 'saving' }> = ({ status }) => {
	const { t } = useTranslation();
	const title = status === 'saved' ? t('Updated') : t('Updating...');
	const icon = status === 'saved' ? 'cloudSaved' : 'refreshRound';

	return (
		<Tooltip title={title}>
			<Box data-testid={`auto-save-${status}`}>
				<Icon component={getMuiIcon(icon)} />
			</Box>
		</Tooltip>
	);
};

export default AutoSave;
